module.exports = __webpack_public_path__ + "static/media/v03-01.3b4217ac.png";